// extracted by mini-css-extract-plugin
export default {"background":"serumlar_background__XYl63","headers":"serumlar_headers__p74Zk","boxs":"serumlar_boxs__x6nlH","border":"serumlar_border__wixGg"};